var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ia-block-card confirmar-perfil-card",
      attrs: {
        role: "group",
        "aria-label": _vm.texts.TITULO,
        "data-teste": "confirmar-perfil-card"
      }
    },
    [
      _c(
        "div",
        { staticClass: "ia-block-card__cabecalho" },
        [
          _c("icon-svg", {
            staticClass: "ia-block-card__icone",
            attrs: { name: "user-2", size: 14, color: "var(--primary)" }
          }),
          _c("span", { staticClass: "ia-block-card__titulo" }, [
            _vm._v(_vm._s(_vm.texts.TITULO))
          ])
        ],
        1
      ),
      _c("div", { staticClass: "ia-block-card__corpo" }, [
        _c("p", { staticClass: "az-ds-aux mb-3" }, [
          _vm._v(_vm._s(_vm.texts.DESCRICAO))
        ]),
        _c(
          "div",
          { staticClass: "d-flex flex-column az-gap-small" },
          [
            _c("input-by-type", {
              attrs: {
                type: "text",
                label: _vm.texts.CAMPO_NOME,
                disabled: _vm.salvando,
                "data-test": "confirmar-perfil-nome"
              },
              model: {
                value: _vm.nome,
                callback: function($$v) {
                  _vm.nome = $$v
                },
                expression: "nome"
              }
            }),
            _c("input-by-type", {
              attrs: {
                type: "text",
                label: _vm.texts.CAMPO_PAPEL,
                disabled: _vm.salvando,
                "data-test": "confirmar-perfil-papel"
              },
              model: {
                value: _vm.papel,
                callback: function($$v) {
                  _vm.papel = $$v
                },
                expression: "papel"
              }
            }),
            _c("input-by-type", {
              attrs: {
                type: "text",
                label: _vm.texts.CAMPO_OBJETIVO,
                disabled: _vm.salvando,
                "data-test": "confirmar-perfil-objetivo"
              },
              model: {
                value: _vm.objetivo,
                callback: function($$v) {
                  _vm.objetivo = $$v
                },
                expression: "objetivo"
              }
            })
          ],
          1
        ),
        _vm.erro
          ? _c(
              "p",
              {
                staticClass: "confirmar-perfil-card__erro mt-3 mb-0",
                attrs: { role: "alert", "data-teste": "erro" }
              },
              [_vm._v(" " + _vm._s(_vm.erro) + " ")]
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "d-flex align-center az-gap-small mt-4" },
          [
            _c(
              "BaseButton",
              {
                attrs: { underlined: "", disabled: _vm.salvando },
                on: {
                  click: function($event) {
                    return _vm.$emit("dispensar")
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.texts.DISPENSAR) + " ")]
            ),
            _c(
              "BaseButton",
              {
                attrs: {
                  primary: "",
                  loading: _vm.salvando,
                  disabled: _vm.travado,
                  "data-test": "confirmar-perfil-salvar"
                },
                on: { click: _vm.confirmar }
              },
              [_vm._v(" " + _vm._s(_vm.texts.SALVAR) + " ")]
            ),
            _vm.vazio && !_vm.salvando
              ? _c(
                  "span",
                  { staticClass: "az-ds-aux confirmar-perfil-card__motivo" },
                  [_vm._v(" " + _vm._s(_vm.texts.VAZIO) + " ")]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }